import React from "react";

export const PrjCol: React.FC = ({ children }) => {
  return <div className="prj__col-wrapper">{children}</div>;
};
